import { Logger } from "@/lib/logger/Logger";
import { MessageContent } from "../../../../lib/store/Realtime/message.types";
import { MessageType } from "../../../../lib/store/Realtime/message.types";
import {
	JobRequestMessageV1,
	TextMessage,
} from "../../../../lib/store/Realtime/message.types";

export const getMessageContent = (content: string): MessageContent => {
	if (!content) {
		return {
			type: MessageType.TEXT,
			text: "",
		};
	}
	try {
		return typeof content === "string"
			? (JSON.parse(content) as MessageContent)
			: (content as MessageContent);
	} catch (error) {
		Logger.error("Error parsing message content", {}, { content, error });
		return {
			type: MessageType.TEXT,
			text: "Nachricht konnte nicht geladen werden.",
		};
	}
};

export const getMessagePreview = (content: string, isSender: boolean) => {
	const newContent = getMessageContent(content);

	switch (newContent.type) {
		case MessageType.JOB_REQUEST_V1:
			return getJobRequestMessagePreview(
				newContent as JobRequestMessageV1,
				isSender
			);
		case MessageType.JOB_REQUEST_CUSTOM_V1:
			return getCustomJobRequestMessagePreview(
				isSender
			);
		case MessageType.TEXT:
			return getTextMessagePreview(newContent as TextMessage, isSender);
		case MessageType.JOB_REQUEST_DENIED:
			return "Auftragsanfrage wurde abgelehnt";
		case MessageType.JOB_REQUEST_ACCEPTED:
			return "Auftragsanfrage wurde angenommen";
		case MessageType.CONNECTION_REQUEST_ACCEPTED:
			return "Verbindungsanfrage wurde angenommen";
		case MessageType.CONNECTION_REQUEST_DENIED:
			return "Verbindungsanfrage wurde abgelehnt";
		case MessageType.SHARED_FILE:
			return "Datei wurde geteilt";
		case MessageType.SHARED_FILE_V2:
			return "Datei wurde geteilt";
		case MessageType.CONNECTION_REQUEST:
			return getConnectionRequestMessagePreview(isSender);
		default:
			return getTextMessagePreview(newContent as TextMessage, isSender);
	}
};

const getJobRequestMessagePreview = (
	content: JobRequestMessageV1,
	isSender: boolean
) => {
	if (isSender) {
		return `Du hast einen Auftrag mit dem Titel "${content.title}" erstellt.`;
	} else {
		return "Du hast einen Auftrag mit dem Titel " + content.title + " erhalten.";
	}
};

const getCustomJobRequestMessagePreview = (
	isSender: boolean
) => {
	if (isSender) {
		return `Du hast einen individuellen Auftrag erstellt.`;
	} else {
		return "Du hast einen individuellen Auftrag erhalten.";
	}
};

const getConnectionRequestMessagePreview = (isSender: boolean) => {
	if (isSender) {
		return `Du hast eine Verbindungsanfrage erstellt.`;
	} else {
		return "Du hast eine Verbindungsanfrage erhalten.";
	}
};

const getTextMessagePreview = (content: TextMessage, isSender: boolean) => {
	const text = content.text.replace(/<[^>]*>/g, "").trim();
	if (!content.text) {
		return "";
	} else if (isSender) {
		return (
			"Du: " + text
		);
	} else {
		return (
			"Nachricht: " + text
		);
	}
};
